'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import CodeSplitEnvWrapper from '../CodeSplitEnvWrapper';

const PlanBuilderCTAsContainer = props => /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
  authedComponentLoader: () => import(
  /* webpackChunkName: "authed-chunk" */
  'pricing-pages-unified-ui/components/plan-builder/PlanBuilderAuthedCtas'),
  publicComponentLoader: () => import(
  /* webpackChunkName: "public-chunk" */
  'pricing-pages-unified-ui/components/plan-builder/PlanBuilderPublicCtas'),
  authedComponentProps: Object.assign({}, props),
  publicComponentProps: Object.assign({}, props)
});

export default PlanBuilderCTAsContainer;